import { publicApiUrl } from './publicApiUrl.js';

let loaded = false;
let loadedAt = 0;
let loadingPromise = null;
const REFRESH_INTERVAL_MS = 15_000;
const BUNDLED_GENERIC_UNIFORM_FALLBACKS = {
  // Keep the patient-facing native bundle aligned with the published Generic NHS defaults
  // when the API cannot be reached from an offline or freshly installed app.
  pre_assessment_nurse: { colourId: 'navy_white', garmentId: 'tunic' },
  surgeon: { colourId: 'no_uniform', garmentId: 'no_uniform' },
  anaesthetist: { colourId: 'green_scrubs', garmentId: 'tunic' },
  hospital_porter: { colourId: 'grey_solid', garmentId: 'tunic' },
};

let uniforms = { ...BUNDLED_GENERIC_UNIFORM_FALLBACKS };


export function invalidateGenericUniformOverrides() {
  loaded = false;
  loadedAt = 0;
}

if (typeof window !== 'undefined') {
  window.addEventListener('focus', invalidateGenericUniformOverrides);
}

export function getGenericUniformOverrides() {
  return uniforms;
}

export function getGenericUniformOverride(role) {
  const keys = [role?.role_key, role?.roleKey, role?.role_id, role?.id].filter(Boolean);
  for (const key of keys) if (uniforms[key]) return uniforms[key];
  return null;
}

export async function loadGenericUniformOverrides({ force = false } = {}) {
  if (!force && loaded && Date.now() - loadedAt < REFRESH_INTERVAL_MS) return uniforms;
  if (loadingPromise) return loadingPromise;
  loadingPromise = fetch(publicApiUrl('/api/generic-uniforms'), { cache: 'no-store' })
    .then(async (response) => {
      if (!response.ok) throw new Error(`Generic uniform service returned ${response.status}`);
      const payload = await response.json();
      uniforms = payload?.uniforms && typeof payload.uniforms === 'object'
        ? { ...BUNDLED_GENERIC_UNIFORM_FALLBACKS, ...payload.uniforms }
        : { ...BUNDLED_GENERIC_UNIFORM_FALLBACKS };
      loaded = true;
      loadedAt = Date.now();
      return uniforms;
    })
    .finally(() => { loadingPromise = null; });
  return loadingPromise;
}

export function applyGenericUniformOverride(role) {
  if (!role) return role;
  const roleKeys = [role?.role_key, role?.roleKey, role?.role_id, role?.id].filter(Boolean);
  if (roleKeys.includes('paramedic')) {
    return {
      ...role,
      uniform_id: 'paramedic_green',
      uniform_color: 'paramedic_green',
      uniform: { ...(role.uniform || {}), id: 'paramedic_green', token: 'paramedic_green', garmentId: 'tunic', note: '' },
    };
  }
  const local = getGenericUniformOverride(role);
  if (!local) return role;
  const colourId = local.colourId || role.uniform_id || role.uniform_color || 'no_uniform';
  const garmentId = local.garmentId || role.uniform?.garmentId || (colourId === 'no_uniform' ? 'no_uniform' : 'tunic');
  return {
    ...role,
    uniform_id: colourId,
    uniform_color: colourId,
    uniform: {
      ...(role.uniform || {}),
      id: colourId,
      token: colourId,
      garmentId,
      note: local.note || '',
    },
  };
}
